const GOOGLE_MAPS_API_KEY = "VITE_GOOGLE_MAPS_API_KEY";
const AZURE_PLACEHOLDER_PATTERN = /^#\{[^}]+\}#$/;

const isUsableValue = (value) =>
  typeof value === "string" &&
  value.trim() !== "" &&
  !AZURE_PLACEHOLDER_PATTERN.test(value.trim());

export const loadRuntimeConfig = async () => {
  try {
    const response = await fetch("/config.json", {
      cache: "no-store",
      credentials: "same-origin",
    });

    if (!response.ok) {
      window.RUNTIME_CONFIG = {};
      return;
    }

    const config = await response.json();
    window.RUNTIME_CONFIG =
      config && typeof config === "object" && !Array.isArray(config)
        ? config
        : {};
  } catch {
    window.RUNTIME_CONFIG = {};
  }
};

export const getGoogleMapsApiKey = (apiKey) => {
  if (isUsableValue(apiKey)) return apiKey.trim();

  const runtimeApiKey = window.RUNTIME_CONFIG?.[GOOGLE_MAPS_API_KEY];
  if (isUsableValue(runtimeApiKey)) return runtimeApiKey.trim();

  return import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "";
};
